'use client';

import useEnhancedEffect from '@mui/utils/useEnhancedEffect';
export const useChartExperimentalFeatures = ({
  params,
  store
}) => {
  useEnhancedEffect(() => {
    store.set('experimentalFeatures', params.experimentalFeatures);
  }, [store, params.experimentalFeatures]);
  return {};
};
useChartExperimentalFeatures.params = {
  experimentalFeatures: true
};
useChartExperimentalFeatures.getInitialState = ({
  experimentalFeatures
}) => {
  return {
    experimentalFeatures
  };
};